import { render, staticRenderFns } from "./FileCategory.vue?vue&type=template&id=fe1dccda"
import script from "./FileCategory.vue?vue&type=script&lang=js"
export * from "./FileCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports